import { inject, Injectable } from '@angular/core';
import { RolloutPlanRequestDto, useRolloutPlanStore } from '@ottobock/remote-update/domain';

@Injectable({
  providedIn: 'root'
})
export class RolloutPlanDetailsService {
  private rolloutPlanStore = inject(useRolloutPlanStore);

  getRolloutPlanDetails(rolloutPlanId: number) {
    return this.rolloutPlanStore.loadRolloutPlanDetails(rolloutPlanId);
  }

  deactivateRolloutPlan(rolloutPlanId: number) {
    return this.rolloutPlanStore.updateRolloutPlanStatus(rolloutPlanId, {
      newStatus: 'Inactive',
      refetch: true
    });
  }

  activateRolloutPlan(rolloutPlanId: number) {
    return this.rolloutPlanStore.updateRolloutPlanStatus(rolloutPlanId, {
      newStatus: 'Active',
      refetch: true
    });
  }

  deleteRolloutPlan(rolloutPlanId: number) {
    return this.rolloutPlanStore.deleteRolloutPlan(rolloutPlanId, {
      refetchAllPlans: true
    });
  }

  getRolloutPlanChangeHistory(rolloutPlanId: number) {
    return this.rolloutPlanStore.loadRolloutPlanChangeHistory(rolloutPlanId);
  }

  getRolloutPlanStatistics(rolloutPlanId: number) {
    return this.rolloutPlanStore.loadCountersPerTargetProductGroup(rolloutPlanId);
  }

  markRolloutPlanReadyForReview(rolloutPlanId: number) {
    return this.rolloutPlanStore.markRolloutPlanReadyForReview(rolloutPlanId, { refetch: true });
  }

  rejectRolloutPlan(rolloutPlanId: number, reason: string | null) {
    return this.rolloutPlanStore.markRolloutPlanRejected(rolloutPlanId, reason, { refetch: true });
  }

  approveRolloutPlan(rolloutPlanId: number) {
    return this.rolloutPlanStore.markRolloutPlanApproved(rolloutPlanId, { refetch: true });
  }

  async updateRolloutPlan(
    rolloutPlanId: number,
    options: { refetchAllPlans?: boolean; metadata: RolloutPlanRequestDto }
  ) {
    return this.rolloutPlanStore.editRolloutPlan(rolloutPlanId, options);
  }
  stopRolloutPlan(rolloutPlanId: number, reason: string) {
    return this.rolloutPlanStore.stopRollout(rolloutPlanId, reason, { refetch: true });
  }
}
